import axios from "axios";

// Instância compartilhada: sempre envia cookies HTTPOnly ao backend.
// No Emergent a tela e o servidor ficam no mesmo host (inclusive em domínio próprio): usa a origem atual.
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const SAME_HOST = /\.(emergent\.host|emergentagent\.com)$/.test(new URL(ENV_URL).hostname);
export const API = `${SAME_HOST ? window.location.origin : ENV_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export default client;

// Converte erros do backend em string segura para render.
export function errorMessage(err, fallback = "Erro") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}
